module.exports = __webpack_public_path__ + "assets/876ea882cf29cef6ad4c6fb279405f4c.mp4";